import type { ReactNode } from "react";
import cx from "ui/cx";
import IconInfoLine from "ui/icons/IconInfoLine";
import Tooltip from "ui/popovers/Tooltip";
import styles from "./TextWithTooltipIcon.module.scss";

export interface TextWithTooltipIconProps {
  text: ReactNode;
  tooltip: string;
  icon?: ReactNode;
  className?: string;
}

export default function TextWithTooltipIcon({ text, tooltip, icon, className = "" }: TextWithTooltipIconProps) {
  return (
    <div className={cx(styles.wrapper, className)}>
      {typeof text === "string" ? <span>{text}</span> : text}
      <Tooltip.Root delayDuration={0}>
        <Tooltip.Trigger asChild>
          <div className="icon-container">{icon ?? <IconInfoLine size={18} color="stone" />}</div>
        </Tooltip.Trigger>
        <Tooltip.Content>{tooltip}</Tooltip.Content>
      </Tooltip.Root>
    </div>
  );
}
